const isProduction = process.env.NODE_ENV === 'production';

const getEnvVariable = (reactKey, fallbackKey, defaultValue = '') => 
    process.env[reactKey] || process.env[fallbackKey] || defaultValue;

const getFrontEndHost = (hostname = window.location.hostname) => {
    const [prefix, ...rest] = hostname.split('.');
    const protocol = window.location.protocol;
    const port = isProduction ? '' : ':3000';
    return `${protocol}//${prefix === 'dev' || prefix === 'qa' || prefix === 'app' ? `app.${prefix}` : `${prefix}-app`}.${rest.join('.')}${port}`;
};

const getUserHost = () => {
    const hostname = window.location.hostname;
    const [prefix, environment, ...rest] = hostname.split('.');
    const userHostPrefix = prefix.replace(/^sales-?/, '');
    const protocol = window.location.protocol;
    const port = isProduction ? '' : ':3001';
    return `${protocol}//${userHostPrefix ? `${userHostPrefix}.${environment}.${rest.join('.')}` : `${environment}.${rest.join('.')}`}${port}`;
}

const getSalesHost = () => {
    const hostname = window.location.hostname;
    const [prefix, ...rest] = hostname.split('.');
    const protocol = window.location.protocol;
    const port = isProduction ? '' : ':3001';
    return `${protocol}//${prefix === 'dev' || prefix === 'qa' || prefix === 'app' ? `sales.${prefix}.${rest.join('.')}` : `sales-${prefix}.${rest.join('.')}`}${port}`;
}

const getConsentHost = () => {
    const hostname = window.location.hostname.replace(/^sales[.-]/, '');
    const [prefix] = hostname.split('.');
    return `https://consent.${hostname}`;
};

const HOSTS = {
    LEAD_INGEST: getEnvVariable('REACT_APP_LEAD_INGEST_HOST', 'LEAD_INGEST_HOST'),
    FRONT_END: getFrontEndHost(),
    VIEW: getEnvVariable('REACT_APP_VIEW_HOST', 'VIEW_HOST'),
    UPLOAD: getEnvVariable('REACT_APP_UPLOAD_HOST', 'UPLOAD_HOST'),
    USER: getUserHost(),
    SALES: getSalesHost(),
    CONSENT: getConsentHost()
};

// Log all host values
Object.entries(HOSTS).forEach(([key, value]) => {
    console.log(`${key}_HOST`, value);
});

export default {
    LEAD_INGEST_HOST: HOSTS.LEAD_INGEST,
    FRONT_END_HOST: HOSTS.FRONT_END,
    VIEW_HOST: HOSTS.VIEW, 
    UPLOAD_HOST: HOSTS.UPLOAD,
    USER_HOST: HOSTS.USER,
    SALES_HOST: HOSTS.SALES,
    CONSENT_HOST: HOSTS.CONSENT
};
